import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import type { DesignModerationStatus } from "../types";

interface DesignStatusBadgeProps {
  status: DesignModerationStatus;
}

const statusClass: Record<DesignModerationStatus, string> = {
  draft: "bg-neutral-500/20 text-neutral-300 border-neutral-500/30",
  pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  approved: "bg-green-500/20 text-green-400 border-green-500/30",
  rejected: "bg-red-500/20 text-red-400 border-red-500/30",
};

const DesignStatusBadge = ({ status }: DesignStatusBadgeProps) => {
  const { t } = useTranslation("common");
  const labels: Record<DesignModerationStatus, string> = {
    draft: t("DESIGNS.statusDraft", "Draft"),
    pending: t("DESIGNS.statusPending", "Pending"),
    approved: t("DESIGNS.statusApproved", "Approved"),
    rejected: t("DESIGNS.statusRejected", "Rejected"),
  };
  return <Badge className={statusClass[status]}>{labels[status]}</Badge>;
};

export default DesignStatusBadge;
